'use client';

import { useLocalizationContext } from "./usePickerAdapter.mjs";
export const usePickerTranslations = () => useLocalizationContext().localeText;